"use client";
import {
  LinkIcon
} from "./chunk-7LH7ZARU.mjs";
import {
  link_default
} from "./chunk-T45N425O.mjs";
import {
  useLink
} from "./chunk-SGLWUJCW.mjs";
export {
  link_default as Link,
  LinkIcon,
  useLink
};
